<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Edit Member</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/persons" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="updatePerson" v-if="person">
                <div class="row justify-content-md-center">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-md-5">
                        <fg-input type="text"
                                  v-model="person.memberFirstName"
                                  label="Name"
                                  placeholder="Enter Member  Name"
                                  v-validate="rules.memberFirstName"
                                  data-vv-name="Name"
                                  cus-name="Name"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-md-7">
                        <fg-input type="text"
                                  v-model="person.memberImageUrl"
                                  label="URL"
                                  placeholder="Enter URL"
                                  v-validate="rules.memberImageUrl"
                                  data-vv-name="Image URL"
                                  cus-name="Image URL"
                                  :has-errors="errors"
                                  :is-fields="fields"
                                  >
                        </fg-input>
                      </div>
                      <div class="col-md-5">
                        <fg-input type="text"
                                  v-model="person.position"
                                  label="Designation"
                                  placeholder="Enter Designation"
                                  v-validate="rules.position"
                                  data-vv-name="Designation"
                                  cus-name="Designation"
                                  :has-errors="errors"
                                  :is-fields="fields"
                        >
                        </fg-input>
                      </div>
                      <div class="col-3" v-if="status.length">
                        <fg-select
                          v-model="person.active"
                          label="Status"
                          v-validate="rules.active"
                          data-vv-name="active"
                          cus-name="active"
                          :has-errors="errors"
                          :is-fields="fields"
                          :list="status"
                          selectedKey="id"
                        >
                        </fg-select>

                      </div>
                      <div class="col-md-12">
                        <fg-text-area type="text"
                                      v-model="person.biography"
                                      label="Biography"
                                      placeholder="Enter Member Biography"
                                    >
                        </fg-text-area>
                      </div>
                    </div>
                  </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Update Member
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { imageHelpers } from '../../../../helpers/lambda'
    import moment from 'moment'
    export default {
        name: 'EditPerson',
        created (){
        this.$store.dispatch('GETSELECTEDPERSON', this.$route.params.id).then(() =>{
            this.person = this.selectedPerson;
        })
    },
    data () {
        let dateTime = new Date();
        return {
            person: this.selectedPerson || {},
          rules: {
            memberFirstName: {required : true},
            memberImageUrl: {required : true},
            position: {required : true},
            active: {required: true}
          },
          message: {
            error: false,
            text: ''
          },
          status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
        }
    },
    methods: {
        updatePerson () {
          this.$validator.validateAll().then((result) => {
            if(result){

              let updatePerson = () =>{
                this.$store.dispatch('UPDATE_PERSON', this.person)
                  .then((res) => {
                    console.log("UPDATE_EVENT res : ", res);
                    this.showPopup('Success!', 'Member is successfully updated', 'success', ()=>this.$router.push('/admin/persons'))

                  })
                  .catch(err => {
                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                    console.log("UPDATE_PERSON API error : ", err);
                  })
              };
              updatePerson();
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    computed: {...mapGetters([
        'persons', 'selectedPerson']) }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Persons/EditPerson.vue